<template>
  <div class="container_box">
    <!--扫描提货单号-->
    <div class="filter_box">
      <Form :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="threeItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1004196')">
              <Input
                :disabled="!getPermission('ymsPickupOrder_startSorting')"
                :element-id="'scanning'"
                :placeholder="$t('key1004197')"
                @on-enter="enterScanInput"
                prefix="icon-scan"
                clearable
                v-model.trim="trackingNumber">
              </Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <span class="cursor themeColor font-weight-bold" style="line-height: 33px" @click="operationInterface">{{ $t('key1004199') }}</span>
          </Col>
        </Row>
      </Form>
    </div>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002399')" prop="ymsWarehouseId">
              <Select v-model="pageParams.ymsWarehouseId" filterable>
                <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '110px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003158')" prop="workBy">
              <Select v-model="pageParams.workBy" style="width: 200px;" filterable>
                <Option v-for="item in updatedByList" :key="item.userId" :value="item.userId">{{ item.userName }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownDateTime
              ref="dropDownDateTime"
              :dropDownTimeList="dropDownTimeList"
              :defaultSelectValue="defaultSelectTimeValue"
              @changeInput="changeTimeInput"
              @selectTime="selectTime"
              @resetTime="resetTime">
            </dropDownDateTime>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--列表区域-->
    <div class="content_box">
      <div class="flex align-items-center justify-content-between mb20">
        <div class="sort_options_box">
          <span>{{ $t('key1004200') }}</span>
          <local-tabButton :tabButtonList="billStatusList" @selectStatus="billStatusBtn"></local-tabButton>
        </div>
        <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsPickupOrder_batchExport')">
          <Button type="primary">
            <span>{{ $t('key1003082') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
            <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div class="table_box">
        <Table
          ref="selection"
          highlight-row
          border
          max-height="520"
          :loading="tableLoading"
          :columns="tableColumns"
          @on-selection-change="tableChange"
          :data="tableData">
        </Table>
        <Page
          :transfer="true"
          v-if="!tableLoading"
          :total="total"
          @on-change="changePage"
          show-total
          :page-size="pageParams.pageSize"
          show-elevator
          :current="pageParams.pageNum"
          show-sizer
          @on-page-size-change="changePageSize"
          placement="top"
          :page-size-opts="pageArray">
        </Page>
      </div>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1004198')"
      paramKeyColums="ymsEntryPickupOrderExportColumns"
      :dimensionTypeList="dimensionTypeList"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import dropDownDateTime from "@/components/common/dropDownDateTime";
import exportFieldsModal from "@/components/common/exportFieldsModal";
import {
  getUserNameByUserId, pageJump, setConfigCharacters, getYmsUserWarehouseOpersUserName,
  getEnableWarehouseData, getWarehouseName, getAllUsersInfo, getDataSetBatchList, getEnumList
} from "@/utils/common";
import dropDownFilter from "@/components/common/dropDownFilter.vue";

export default {
  name: "commoditySorting",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      trackingNumber: '',
      pageParams: {
        status: null, // 状态
        ymsWarehouseId: 'null', // 所属仓库
        storageTimeDown: null,
        storageTimeUp: null, // 入库操作时间
        supplierPickupOrderNumberList: '', // 提货单号
        thirdPickupOrderNumbers: '', // 三方提单号
        workBy: null, // 操作人
        workEndTimeDown: null,
        workEndTimeUp: null, //  作业结束时间
        workStartTimeDown: null, // 作业开始时间
        workStartTimeUp: null,
        pageNum: 1,
        pageSize: 15,
      },
      total: 0,
      tableColumns: [],
      tableData: [],
      billStatusList: [],
      sortTableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004116'),
          key: 'supplierPickupOrderNumber',
          minWidth: 160,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004047'),
          key: 'thirdPickupOrderNumber',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            let thirdPickupOrderNumber = params.row.thirdPickupOrderNumber || '-';
            return h('span', thirdPickupOrderNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001571'),
          key: 'logisticsInfo',
          align: 'center',
          minWidth: 230,
          render(h, params) {
            let carrierName = params.row.carrierName || '-';
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            let expressageCode = params.row.expressageCode;
            let text = '-';
            let expressageNo = params.row.expressageNo;
            let trackingNumber = params.row.trackingNumber;
            let code = deliveryType === 2 ? expressageNo : trackingNumber;
            if (deliveryType === 1 && transportType === 2) {
              text = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')}`;
            } else {
              if (transportType === 1 && deliveryType === 1) {
                text = carrierName;
              } else {
                if (v.useLogisticsList.length > 0) {
                  v.useLogisticsList.map((item) => {
                    if (item.carrierId === expressageCode) {
                      text = item.carrierName;
                    }
                  });
                }
              }
            }
            return h('div', [
              h('p', text),
              h('p', code)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004180'),
          key: 'status',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let text = '';
            v.billStatusList.map((item) => {
              if (item.value === params.row.status) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004181'),
          key: 'labelType',
          minWidth: 140,
          align: 'center',
          render: (h, params) => {
            let text = '-';
            let status = params.row.labelType;
            v.labelTypeList.map((item) => {
              if (item.value === status) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390'),
          key: 'warehouseName',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          minWidth: 140,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004182'),
          key: 'packageQuantity',
          minWidth: 140,
          sortable: true,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846'),
          key: 'storageTime',
          minWidth: 180,
          align: 'center',
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.storageTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'storageBy',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.storageBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 130,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004183'),
                    show: v.getPermission('ymsPickupOrder_startSorting'),
                    clickFn: () => {
                      v.$router.push({
                        path: '/commoditySortingOperation',
                        query: {
                          supplierPickupOrderNumber: params.row.supplierPickupOrderNumber
                        }
                      });
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ], // 待分拣
      sortingTableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004116'),
          key: 'supplierPickupOrderNumber',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004047'),
          key: 'thirdPickupOrderNumber',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            let thirdPickupOrderNumber = params.row.thirdPickupOrderNumber || '-';
            return h('span', thirdPickupOrderNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004180'),
          key: 'status',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let text = '';
            v.billStatusList.map((item) => {
              if (item.value === params.row.status) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004181'),
          key: 'labelType',
          align: 'center',
          minWidth: 130,
          render: (h, params) => {
            let text = '-';
            let status = params.row.labelType;
            v.labelTypeList.map((item) => {
              if (item.value === status) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          minWidth: 140,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004182'),
          key: 'packageQuantity',
          minWidth: 140,
          sortable: true,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846'),
          key: 'storageTime',
          minWidth: 180,
          align: 'center',
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.storageTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054'),
          key: 'pickingStartTime',
          minWidth: 180,
          align: 'center',
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.pickingStartTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004058'),
          key: 'time',
          align: 'center',
          minWidth: 180,
          sortable: true,
          render: (h, params) => {
            //分拣开始时间
            let startTime = v.$uDate.dealTime(params.row.pickingStartTime, 'fulltime');
            //当前时间
            let currentTime = v.$uDate.getCurrentTime('fulltime');
            if (startTime && currentTime) {
              let timeStamp = (new Date(currentTime).getTime() - new Date(startTime).getTime()) / 1000;
              return h('span', v.$uDate.timeStampTime(timeStamp));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'pickingStartBy',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.pickingStartBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 130,
          render(h, params) {
            let talg = v.userInfo.userId === params.row.pickingStartBy && v.getPermission('ymsPickupOrder_startSorting');
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001251'),
                    show: talg,
                    clickFn: () => {
                      v.$router.push({
                        path: '/commoditySortingOperation',
                        query: {
                          supplierPickupOrderNumber: params.row.supplierPickupOrderNumber
                        }
                      });
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ], // 分拣中
      sortedTableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004116'),
          key: 'supplierPickupOrderNumber',
          minWidth: 160,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004047'),
          key: 'thirdPickupOrderNumber',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            let thirdPickupOrderNumber = params.row.thirdPickupOrderNumber || '-';
            return h('span', thirdPickupOrderNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004180'),
          key: 'status',
          align: 'center',
          minWidth: 110,
          render(h, params) {
            let text = '';
            v.billStatusList.map((item) => {
              if (item.value === params.row.status) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004181'),
          key: 'labelType',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let text = '-';
            let status = params.row.labelType;
            v.labelTypeList.map((item) => {
              if (item.value === status) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          minWidth: 140,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004184'),
          key: 'packageQuantity',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004185'),
          key: 'realPickingQuantity',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004186'),
          key: 'ymsContainerCodeList',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            let text = '';
            let ymsContainerCodeList = params.row.ymsContainerCodeList;
            if (ymsContainerCodeList && ymsContainerCodeList.length > 0) {
              text = ymsContainerCodeList.join('、');
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846'),
          key: 'storageTime',
          align: 'center',
          minWidth: 180,
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.storageTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054'),
          key: 'pickingStartTime',
          align: 'center',
          minWidth: 180,
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.pickingStartTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004057'),
          key: 'pickingEndTime',
          align: 'center',
          minWidth: 180,
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.pickingEndTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004058'),
          key: 'time',
          align: 'center',
          minWidth: 180,
          sortable: true,
          render: (h, params) => {
            let startTime = v.$uDate.dealTime(params.row.pickingStartTime, 'fulltime');
            let endTime = v.$uDate.dealTime(params.row.pickingEndTime, 'fulltime');
            if (startTime && endTime) {
              let timeStamp = (new Date(endTime).getTime() - new Date(startTime).getTime()) / 1000;
              return h('span', v.$uDate.timeStampTime(timeStamp));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'pickingEndBy',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.pickingEndBy, v.userInfoList));
          }
        }
      ], // 已分拣
      updatedByList: [],
      defaultSelectTimeValue: 1,
      dropDownTimeList: [],
      warehouseList: [],
      supplierPickupOrderNumber: null,
      dimensionTypeList: [
        {value: 1, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004120')},
        {value: 2, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004060')}
      ],
      selectTableData: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'supplierPickupOrderNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004116')},
            {paramKey: 'thirdPickupOrderNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004047')},
            {paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004180')},
            {paramKey: 'labelType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004181')},
            {paramKey: 'supplierMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
            {paramKey: 'packageQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004184')},
            {paramKey: 'pickQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004185')},
            {paramKey: 'ymsSku', paramValue: 'SKU'},
            {paramKey: 'skuQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004187')},
            {paramKey: 'ymsContainerCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004186')},
            {paramKey: 'storageTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004188')},
            {paramKey: 'pickingStartTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004189')},
            {paramKey: 'pickingEndTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004190')},
            {paramKey: 'dateLength', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004058')},
            {paramKey: 'pickingEndBy', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004191')},
          ]
        }
      ],
      useLogisticsList: [],
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001775'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003849'), parameterKey: 'supplierPickupOrderNumberList'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004047'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004115'), parameterKey: 'thirdPickupOrderNumbers'}
      ],
      defaultSelectValue: 1,
      userInfoList: {},
      enumData: []
    };
  },
  mounted() {
    let v = this;
    v.$nextTick(() => {
      v.getFocus('scanning');
    });
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    filterKeyList() {
      return this.dropDownInputList.map((item) => {
        return item.parameterKey;
      });
    },
    // 面单类型
    labelTypeList() {
      const ENUM_KEY = 'YmsPickupOrderLabelTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY);
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      this.updatedByList = [];
      let roleList = this.$store.state.roleList;
      let newList = [];
      let list = [
        {selected: false, value: 21, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004192'), jurisdictionKey: 'ymsPickupOrder_queryWaitSortingList'},
        {selected: false, value: 3, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004193'), jurisdictionKey: 'ymsPickupOrder_querySortingList'},
        {selected: false, value: 4, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003695'), jurisdictionKey: 'ymsPickupOrder_querySortedList'},
      ];
      list.map((item) => {
        if (roleList[item.jurisdictionKey]) {
          newList.push(item);
        }
      });
      list[0].selected = true;
      this.billStatusList = list;
      this.warehouseList = [];
      (async () => {
        let enumKeyList = ['YmsPickupOrderLabelTypeCoreEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
        });
        await this.getUseLogistics();
        await getEnableWarehouseData(1).then((data) => {
          this.warehouseList = [{ymsWarehouseId: 'null', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')}, ...data];
        });
        // 查询商户下拥有所有授权仓库的用户
        await getYmsUserWarehouseOpersUserName(this.userInfo.userId).then((data) => {
          if (data) {
            for (let key in data) {
              this.updatedByList.push(data[key]);
            }
          }
        });
        if (this.getPermission('ymsPickupOrder_queryWaitSortingList')) {
          this.pageParams.status = 21;
          await this.getSortList();
        } else if (this.getPermission('ymsPickupOrder_querySortingList')) {
          this.pageParams.status = 3;
          await this.getSortingList();
        } else if (this.getPermission('ymsPickupOrder_querySortedList')) {
          this.pageParams.status = 4;
          await this.getSortedList();
        }
        await this.getSortingProgressOptions();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.trackingNumber = '';
      v.$refs['pageParams'].resetFields();
      v.changeTimeInput(1);
      v.changeInput(1);
      if (v.pageParams.status === 4) {
        v.setDefaultTimerParams('three_months', 1);
      }
      v.pageParamsStatus = true;
    },
    // 提货单号的回车键
    enterScanInput() {
      let v = this;
      if (v.trackingNumber !== '') {
        // 判断当前是否有未完成分拣的
        v.axios.put(api.put_ymsPickupOrder_startSorting + `?businessId=${v.trackingNumber}`).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.$router.push({
                path: '/commoditySortingOperation',
                query: {
                  supplierPickupOrderNumber: v.trackingNumber
                }
              });
            }
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004067'));
        return false;
      }
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.ymsWarehouseId = v.pageParams.ymsWarehouseId === 'null' ? null : v.pageParams.ymsWarehouseId;
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      return params;
    },
    // 获取待分拣列表数据
    getSortList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsPickupOrder_queryWaitSortingList')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsPickupOrder_queryWaitSortingList, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取分拣中列表数据
    getSortingList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsPickupOrder_querySortingList')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsPickupOrder_querySortingList, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let list = data.list || [];
              v.tableData = list;
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取已分拣列表数据
    getSortedList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsPickupOrder_querySortedList')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsPickupOrder_querySortedList, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取选中的时间
    selectTime(data) {
      let v = this;
      let time = data.date;
      let timeList = v.defaultTimePeriod(time);
      let current = data.value;
      v.dropDownTimeList.map((item) => {
        if (item.value === current) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          v.$nextTick(() => {
            v.$refs['dropDownDateTime'].timeList = v.defaultTimePeriod(time, false);
          });
          v.pageParams[startTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams[endTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      });
    },
    // 改变默认下拉选项的值
    changeTimeInput(value) {
      this.defaultSelectTimeValue = value;
      this.$refs['dropDownDateTime'].timeList = [];
      this.dropDownTimeList.map((item) => {
        let startTimeKey = item.parameterKey[0];
        let endTimeKey = item.parameterKey[1];
        this.pageParams[startTimeKey] = null;
        this.pageParams[endTimeKey] = null;
      });
    },
    // 重置选中的时间
    resetTime(value) {
      this.dropDownTimeList.map((item) => {
        if (item.value === value) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          this.pageParams[startTimeKey] = null;
          this.pageParams[endTimeKey] = null;
        }
      });
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 选取提货单状态
    billStatusBtn(index, value) {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.pageParams.status = value;
      v.billStatusList.forEach((n, i) => {
        n.selected = i === index;
      });
      if (v.pageParams.status === 4) {
        v.setDefaultTimerParams('three_months', 1);
      }
      v.pageParamsStatus = true;
      v.$forceUpdate();
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data.map((item) => {
          return item.ymsPickupOrderId;
        });
      }
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsPickupOrderIds = v.selectTableData;
      } else {
        query.ymsPickupOrderIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          query.exportType = obj.dimensionType;
          v.axios.post(api.post_ymsPickupOrder_batchExport, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 根据状态处理列表字段和筛选条件
    handleFilter(data) {
      let v = this;
      v.tableColumns = [];
      v.dropDownTimeList = [];
      let filterTimeList = [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846'), value: 1, parameterKey: ['storageTimeUp', 'storageTimeDown']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054'), value: 2, parameterKey: ['workStartTimeUp', 'workStartTimeDown']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004057'), value: 3, parameterKey: ['workEndTimeUp', 'workEndTimeDown']}
      ];
      data.map((item) => {
        if (item.selected) {
          if (item.value === 21) {
            v.tableColumns = v.sortTableColumns;
            v.dropDownTimeList = filterTimeList.slice(0, 1);
            v.$forceUpdate();
          } else if (item.value === 3) {
            v.tableColumns = v.sortingTableColumns;
            v.dropDownTimeList = filterTimeList.slice(0, 2);
            v.$forceUpdate();
          } else {
            v.tableColumns = v.sortedTableColumns;
            v.dropDownTimeList = filterTimeList;
            v.$forceUpdate();
          }
        }
      });
    },
    // 查询当前用户是否有正在分拣中的操作
    getSortingProgressOptions() {
      let v = this;
      v.supplierPickupOrderNumber = null;
      v.axios.get(api.get_ymsPickupOrder_getSortingOrder + `?userId=${v.userInfo.userId}`).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.supplierPickupOrderNumber = data.supplierPickupOrderNumber;
            if (v.supplierPickupOrderNumber) {
              if (v.getPermission('ymsPickupOrder_startSorting')) {
                v.$Modal.confirm({
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004194'),
                  content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004195'),
                  onOk: () => {
                    v.$router.push({
                      path: '/commoditySortingOperation',
                      query: {
                        supplierPickupOrderNumber: v.supplierPickupOrderNumber
                      }
                    });
                  },
                  onCancel: () => {
                  }
                });
              }
            }
          }
        }
      });
    },
    // 进入作业界面
    operationInterface() {
      let v = this;
      if (v.supplierPickupOrderNumber) {
        v.$router.push({
          path: '/commoditySortingOperation',
          query: {
            supplierPickupOrderNumber: v.supplierPickupOrderNumber
          }
        });
      } else {
        v.$router.push('/commoditySortingOperation');
      }
    },
    // 获取使用过的物流商数据
    getUseLogistics() {
      this.useLogisticsList = [];
      this.axios.get(api.get_expressageHundred_query + '?type=kuaidi100').then(response => {
        if (response.data.code === 0) {
          let typeShippingList = response.data.datas || [];
          if (typeShippingList.length > 0) {
            this.axios.get(api.get_ymsPickupOrder_queryLogistics).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas || [];
                if (data.length > 0) {
                  data.map((item) => {
                    typeShippingList.map((ele) => {
                      if (item.carrierId === ele.code) {
                        item.carrierName = ele.name;
                      }
                    });
                  });
                  this.useLogisticsList = data;
                  this.useLogisticsList.unshift({carrierId: "ymspickcollec", carrierName: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')}`});
                }
              }
            });
          }
        }
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        if (v.pageParams.status === 21) {
          v.getSortList();
        } else if (v.pageParams.status === 3) {
          v.getSortingList();
        } else if (v.pageParams.status === 4) {
          v.getSortedList();
        }
        v.pageParamsStatus = false;
      }
    },
    // 监听提货单状态
    billStatusList: {
      handler(data) {
        let v = this;
        v.handleFilter(data);
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    dropDownFilter,
    dropDownDateTime,
    exportFieldsModal
  }
};
</script>

<style lang="less" scoped>
.filter_box /deep/ .ivu-form-item {
  margin: 0 !important;
}

.content_box {
  padding: 15px 15px 10px 15px;
  background-color: #fff;
  border-radius: 3px;
}

.table_box {
  background-color: #fff;

  /deep/ .ivu-tabs-bar {
    padding: 0 25px;
  }

  /deep/ .ivu-tabs-content {
    padding: 10px 25px 25px 25px;
  }
}
</style>
